import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setLeaseTerm, setLeaseTermUnits } from 'bundles/apex/deals/form/store/deal/actions';

import DealField from 'bundles/apex/deals/form/fields/field';
import WithUnits from 'bundles/apex/deals/form/fields/with_units';
import { getLeaseTermUnitsLabel } from 'bundles/apex/deals/helpers/labels';
import { calculatesLeaseTerm } from 'bundles/apex/deals/lease_terms/helpers';

const unitOptions = ['months', 'years'].map(value => ({
  label: getLeaseTermUnitsLabel(value),
  value: value,
}));

export function LeaseTerm({ deal, invalid, setLeaseTerm, setLeaseTermUnits, ...props }) {
  return (
    <WithUnits
      {...props}
      deal={deal}
      disabled={calculatesLeaseTerm(deal)}
      invalid={invalid}
      unitOptions={unitOptions}
      onUnitsChange={setLeaseTermUnits}
      onValueChange={setLeaseTerm}
    />
  );
}

LeaseTerm.propTypes = {
  deal: PropTypes.object.isRequired,
  invalid: PropTypes.bool,
  setLeaseTerm: PropTypes.func.isRequired,
  setLeaseTermUnits: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setLeaseTerm,
  setLeaseTermUnits,
};

export default connect(null, mapDispatchToProps)(DealField(LeaseTerm, 'leaseTerm'));
